import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Clock } from "lucide-react";
import { Link } from "react-router-dom";

interface StreamCardProps {
  id?: number;
  title: string;
  description?: string | null;
  streamer: string;
  viewers?: number;
  isLive?: boolean | null;
  thumbnail?: string;
  scheduledTime?: string;
}

const StreamCard = ({
  id,
  title,
  description,
  streamer,
  viewers = 0,
  isLive = false,
  thumbnail,
  scheduledTime
}: StreamCardProps) => {
  const cardContent = (
    <Card className="overflow-hidden group hover:shadow-glow-primary transition-smooth cursor-pointer">
      <div className="relative aspect-video bg-secondary">
        {thumbnail && (
          <img src={thumbnail} alt={title} className="w-full h-full object-cover" />
        )}
        {isLive && (
          <div className="absolute top-3 left-3">
            <span className="bg-destructive px-3 py-1 rounded-full text-xs font-bold animate-pulse-glow shadow-glow-live">
              LIVE
            </span>
          </div>
        )}
        {!isLive && scheduledTime && (
          <div className="absolute top-3 left-3 bg-secondary/90 backdrop-blur-sm px-3 py-1 rounded-full flex items-center gap-2">
            <Clock className="w-3 h-3" />
            <span className="text-xs font-semibold">{scheduledTime}</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent opacity-0 group-hover:opacity-100 transition-smooth flex items-end justify-center pb-4">
          <Button variant="hero">Watch Stream</Button>
        </div>
      </div>
      
      <div className="p-4">
        <h3 className="font-bold text-lg mb-1 line-clamp-1">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground/80 mb-2 line-clamp-2">{description}</p>
        )}
        <p className="text-muted-foreground text-sm mb-3">{streamer}</p>

        {isLive && (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Users className="w-4 h-4" />
            <span className="text-sm">{viewers.toLocaleString()} viewers</span>
          </div>
        )}
      </div>
    </Card>
  );

  if (id) {
    return <Link to={`/stream/${id}`}>{cardContent}</Link>;
  }

  return cardContent;
};

export default StreamCard;
